import { useMemo } from 'react';
import { DeMythosConsole } from './demythos/DeMythosConsole';
import { useSupabaseStore } from '@/store/SupabaseStore';
import { filterEnabledModels } from '@/lib/modelSettings';
import type { SshProfile } from '@/OS/types/ssh';

interface TerminalBridgeResult {
  kind: 'output';
  text: string;
}

interface TerminalBridgeInputResult {
  kind: 'input';
  prompt: string;
  secret?: boolean;
}

type DeMythosTerminalResult = TerminalBridgeResult | TerminalBridgeInputResult;

interface DeMythosProps {
  onExit?: () => void;
  initialPrompt?: string;
  sshProfiles?: SshProfile[];
  runTerminalCommand?: (command: string) => Promise<DeMythosTerminalResult>;
  submitTerminalInput?: (input: string) => Promise<DeMythosTerminalResult>;
}

export default function DeMythos({ onExit, initialPrompt, sshProfiles, runTerminalCommand, submitTerminalInput }: DeMythosProps) {
  const allModels = useSupabaseStore((state) => state.models);
  const models = useMemo(() => filterEnabledModels(allModels), [allModels]);

  return (
    <DeMythosConsole
      models={models}
      onExit={onExit}
      initialPrompt={initialPrompt}
      sshProfiles={sshProfiles}
      runTerminalCommand={runTerminalCommand}
      submitTerminalInput={submitTerminalInput}
    />
  );
}